/** @jsx jsx */
import { jsx } from 'theme-ui'
import { graphql, useStaticQuery } from 'gatsby'
import Banner from './Banner'

const SubNavAlert = ({ hide, subPromoAlert }) => {
  return <Banner hide={hide} data={subPromoAlert} />
}

export default SubNavAlert
